var brandVariant = '_117fsfs2';
var closeWrapper = '_117fsfse';
var content = '_117fsfsb';
var dangerVariant = '_117fsfs3';
var defaultVariant = '_117fsfs1';
var fullWidthType = '_117fsfs6';
var iconContainer = '_117fsfsc';
var informationalType = '_117fsfs8';
var inlineType = '_117fsfs7';
var insetModalType = '_117fsfs9';
var insetType = '_117fsfsa';
var link = '_117fsfsg _14wijgra';
var message = '_117fsfsd _14wijgr9';
var messageTitle = '_14wijgra';
var root = '_117fsfs0';
var successVariant = '_117fsfs5';
var warnVariant = '_117fsfs4';

export { brandVariant, closeWrapper, content, dangerVariant, defaultVariant, fullWidthType, iconContainer, informationalType, inlineType, insetModalType, insetType, link, message, messageTitle, root, successVariant, warnVariant };
//# sourceMappingURL=banner.css.js.map
